import { render, staticRenderFns } from "./RiskDebtEditBlock.vue?vue&type=template&id=52c99c84&scoped=true"
import script from "./RiskDebtEditBlock.vue?vue&type=script&lang=js"
export * from "./RiskDebtEditBlock.vue?vue&type=script&lang=js"
import style0 from "./RiskDebtEditBlock.vue?vue&type=style&index=0&id=52c99c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c99c84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCardActions,VCol,VContainer,VForm,VRow,VSelect,VSpacer,VTextField,VToolbar,VToolbarTitle})
